import moment from 'moment';
import { BookingListModel, BookingModel } from '../models/booking.model';
import { SeminarAttendeeModel } from '../models/seminar.model';

export function getStatus(
  booking: BookingListModel | BookingModel | SeminarAttendeeModel
): {
  status: string;
  class: string;
} {
  if (
    booking.status === 'pending' &&
    moment(booking.createdAt).isBefore(moment().subtract(14, 'days'))
  ) {
    return { status: 'Verspätet', class: 'inwi-chip-text-yellow-outline' };
  }
  switch (booking.status) {
    case 'confirmed':
      return { status: 'Bezahlt', class: 'inwi-chip-text-green-outline' };
    case 'pending':
      return { status: 'Ausstehend', class: 'inwi-chip-text-grey-outline' };
    case 'cancelled':
      return { status: 'Storniert', class: 'inwi-chip-text-red-outline' };
    case 'waitlist':
      return { status: 'Warteliste', class: 'inwi-chip-text-red-outline' };
    case 'late':
      return { status: 'Verspätet', class: 'inwi-chip-text-yellow-outline' };
    default:
      return { status: 'Unbekannt', class: 'inwi-chip-text-grey-outline' };
  }
}

export function getStatusString(booking: BookingListModel): string {
  if (
    booking.status === 'pending' &&
    moment(booking.createdAt).isBefore(moment().subtract(14, 'days'))
  ) {
    return 'Verspätet';
  }
  switch (booking.status) {
    case 'confirmed':
      return 'Bezahlt';
    case 'pending':
      return 'Ausstehend';
    case 'cancelled':
      return 'Storniert';
    case 'waitlist':
      return 'Warteliste';
    case 'late':
      return 'Verspätet';
    default:
      return 'Unbekannt';
  }
}
